import { Badge } from "../common/Badge";
import { useSubscription } from "../../context/SubscriptionContext";

export function SubscriptionBadge() {
  const { tierLabel, isFree } = useSubscription();

  /*
   * NOTHING, rather than a guess (#412). tierLabel is null until the
   * subscription lookup resolves and stays null if it fails, and this
   * badge used to render "Free" in that gap -- so a Business account was
   * told it was on the free plan while every paid page worked, which
   * reads as the features being wrong rather than the badge.
   *
   * An absent badge is a smaller wrong answer than a confident one.
   */
  if (!tierLabel) return null;

  return <Badge tone={isFree ? "neutral" : "success"}>{tierLabel}</Badge>;
}
